import React from "react";
import BackBar from "../../../../common/nav/BackBar";
import styles from "../../../../common/mypage/user-settings/Settings.module.scss";
import SonicLink from "../../../../common/routing/SonicLink";

const ProjectTop: React.FC = () => {
  return (
    <>
      <div className={styles["p-dbsettings"]}>
        <div className={styles["p-dbsettings__wrapper"]}>
          <BackBar
            title="プロジェクト"
            editable={false}
            handleClose={() => history.back()}
          />
          <div className={styles["p-projectSettings__box"]}>
            <div className={styles["p-projectSettings__head__link"]}>
              <SonicLink to="/mypage/project/settings">
                プロジェクト一覧・作成・編集
              </SonicLink>
            </div>
            <div className={styles["p-projectSettings__head__link"]}>
              <SonicLink to="/mypage/project/applied">
                応募済みのプロジェクト
              </SonicLink>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ProjectTop;
